import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgAlertsOn = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 60,
	height: 60,
	viewBox: "0 0 60 60",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M30 54.375C32.75 54.375 35 52.125 35 49.375H25C25 52.125 27.25 54.375 30 54.375ZM45 39.375V26.875C45 19.2 40.925 12.775 33.75 11.075V9.375C33.75 7.3 32.075 5.625 30 5.625C27.925 5.625 26.25 7.3 26.25 9.375V11.075C19.1 12.775 15 19.175 15 26.875V39.375L9.99995 44.375V46.875H49.9999V44.375L45 39.375ZM40 41.875H20V26.875C20 20.675 23.775 15.625 30 15.625C36.225 15.625 40 20.675 40 26.875V41.875ZM18.95 9.575L15.375 6C9.37495 10.575 5.42495 17.625 5.07495 25.625H10.075C10.45 19 13.85 13.2 18.95 9.575ZM49.9249 25.625H54.9249C54.5499 17.625 50.6 10.575 44.625 6L41.075 9.575C46.125 13.2 49.5499 19 49.9249 25.625Z",
		fill: "#FBC02D"
	})
});
export default SvgAlertsOn;
